import * as React from 'react';

export const useVisitCount = () => {
  const [visitCount] = React.useState(
    typeof window !== 'undefined' && typeof localStorage !== 'undefined'
      ? parseInt(localStorage.getItem('visitCount') || '0', 10)
      : 0,
  );

  return visitCount;
};
